<script lang="ts">
import type { StudyPayerSegmentBarRow } from '$lib/components/study/slide-layout-types'

/** `.cc` + ranked `.pr` rows (bar width vs `maxCount`); optional cash-pay label styling. */
interface Props {
  title: string
  subtitleHtml: string
  rows: readonly StudyPayerSegmentBarRow[]
  maxCount: number
  formatValue: (count: number) => string
  /** Row `name` matching this label gets cash-pay emphasis (default `Cash Pay`). */
  cashPayLabel?: string
  cardClass?: string
  cardStyle?: string
  listWrapStyle?: string
}

let {
  title,
  subtitleHtml,
  rows,
  maxCount,
  formatValue,
  cashPayLabel = 'Cash Pay',
  cardClass = '',
  cardStyle,
  listWrapStyle = 'margin-top:.88rem;',
}: Props = $props()
</script>

<div class="cc {cardClass}" style={cardStyle}>
  <div class="ct">{title}</div>
  <div class="cs">{@html subtitleHtml}</div>
  <div style={listWrapStyle}>
    {#each rows as { name, count, color }}
      {@const isCash = name === cashPayLabel}
      <div class="pr">
        <div class="pl" style={isCash ? 'color:var(--amb);font-weight:600;' : ''}>
          {name}{isCash ? ' ⚡' : ''}
        </div>
        <div class="pt">
          <div
            class="pf2"
            style="width:{maxCount > 0
              ? ((count / maxCount) * 100).toFixed(1)
              : 0}%;background:{color};"
          ></div>
        </div>
        <div class="pv" style={isCash ? 'color:var(--amb);' : ''}>
          {formatValue(count)}
        </div>
      </div>
    {/each}
  </div>
</div>
